<template>
  <span class="condition-tag-group">
    <span v-show="showPrefix" class="label">{{ prefix }}</span>
    <span class="tag" @click="onAdd('event')">做过(没做过)..</span>
    <span class="tag" @click="onAdd('new')">新增于..</span>
    <span class="tag" @click="onAdd('active')">活跃于..</span>
    <span class="tag" @click="onAdd('user')">用户属性满足..</span>
  </span>
</template>

<script>
export default {
  name: 'conditionTagGroup',
  props: {
    prefix: {
      type: String,
      default: '并且'
    },
    showPrefix: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onAdd(type) {
      this.$emit('add', type)
    }
  }
}
</script>

<style lang="sass">
@import "../../assets/constants"
.condition-tag-group
  height: 34px
  line-height: 34px
  display: inline-block
  .label
    color: $color-font-content
  .tag
    display: inline-block
    width: 100px
    height: 28px
    line-height: 28px
    text-align: center
    font-size: $size-font-mark
    color: $color-status-normal
    background: #f3f8fa
    margin-right: 5px
    border-radius: 50px
    vertical-align: middle
    cursor: pointer
    &:hover
      color: #fff
      background: $color-status-normal
</style>
